<template>
  <Dialog v-model="dialog" width="400">
    <template slot="title">
      <span class="_dialog-title">{{getTitle}}</span>
    </template>

    <template slot="content">
      <section class="pt-4 pb-6">
        <v-form v-model="isFormValid" ref="form" class="d-flex flex-column" style="gap: 24px">
          <TextField 
            v-model="page.name" 
            label="Nome" 
            placeholder="Nova página" 
            :rules="[rules.required, (value) => rules.minLength(value, 4, 'Nome da página precisa ter ao menos')]"
            :hideDetails="false"
          />
          <TextField 
            v-model="page.route" 
            label="Rota" 
            placeholder="novapagina" 
            :hideDetails="false"
            @keyup="onKeyUpRoute" 
            :maxLength="20"
            :rules="[
              rules.required, 
              (value) => rules.minLength(value, 3, 'Rota da página precisa ter ao menos'),
              rules.notAllowedRoutes,
            ]"
          />
        </v-form>
      </section>
    </template>

    <template slot="actions">
      <div class="d-flex justify-end" style="gap: 8px">
        <Button
          outlined
          label="Cancelar"
          text-color="bt_color"
          textSize="0.80rem"
          @click="handleCancel"
        />

        <Button 
          :disabled="!isFormValid"
          label="Confirmar" 
          textSize="0.80rem" 
          @click="handleConfirm"
        />
      </div>
    </template>
  </Dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import { generateId } from '../../../helpers/generateId'
import { createUsingSchema } from '../../../schemas'
import { PAGE_SCHEMA } from '../../../schemas/pages/schema'
import { CONTENT_SCHEMA } from '../../../schemas/sections'
import Dialog from "../../_v2/ui/Dialog.vue"
import TextField from "../../_v2/ui/TextField.vue"
import Button from "../../_v2/ui/Button.vue"

export default {
  name: 'CreatePageDialog',
  components: {Dialog, TextField, Button},
  props: {
    isOpen: {type: Boolean, required: true},
    type: {type: String, required: true}, // add or edit
    placeholder: {type: String},
    pageToEdit: {type: Object, required: false}
  },

  computed: {
    ...mapGetters(['infos']),

    getTitle () {
      if (this.type === 'add') return 'Criar página'
      else return 'Editar página'
    }
  },

  data: () => ({
    dialog: false,
    page: {name: '', route: ''},
    isFormValid: false,
    rules: {
      required: (value) => !!value || "Este campo é obrigatório.",
      minLength: (value, minLength = 3, msg = 'Campo precisa ter ao menos') => value.length >= minLength || `${msg} ${minLength} caracteres`,
      notAllowedRoutes: (value) => !['edit'].includes(value) || 'Essa rota não é permitida'
    }    
  }),

  methods: {
    onKeyUpRoute (event) {
      const regex = /[^a-zA-Z0-9]/g
      const {target} = event
      let value = target.value.toLowerCase()
      value = value.replace(regex, '')
      this.page.route = value
    },

    handleCancel () {
      this.dialog = false
    },

    handleConfirm () {
      if (this.type === 'add') this.onAddPage()
      else this.onEditPage(this.pageToEdit.id)
      this.dialog = false
    },

    onAddPage () {
      const newPage = createUsingSchema(PAGE_SCHEMA({route: `/${this.page.route}`, name: this.page.name}))
      this.infos.pages.push(newPage)

      const layout = this.infos.layout.length > 1 ? this.infos.layout[1].id : ''
      const defaultContent = createUsingSchema(CONTENT_SCHEMA({pageId: newPage.id, idLayout: layout}))
      defaultContent.id = defaultContent.type + `-${generateId()}`
      defaultContent.title.content = 'Conteúdo nova página'
      defaultContent.text.content = 'Adicione um texto aqui'

      this.infos.sections.splice(1, 0, defaultContent)
    },

    onEditPage (id) {
      const pageIndex = this.infos.pages.findIndex(page => page.id === id)
      if (pageIndex !== -1) {
        Object.assign(this.infos.pages[pageIndex], {route: `/${this.page.route}`, name: this.page.name})
      }
    }
  },

  watch: {
    isOpen (value) {
      if (value) {
        if (this.type === 'add') {
          Object.assign(this.page, {name: '', route: ''})
          setTimeout(() => {this.$refs.form.resetValidation()})
        }

        if (this.type === 'edit') {
          Object.assign(this.page, {name: this.pageToEdit.name, route: this.pageToEdit.route.split('/')[1]})
          setTimeout(() => {this.$refs.form.resetValidation()})
        }

        this.dialog = value
      }
    },

    dialog (value) {
      if (!value) this.$emit('onClose')
    }
  },

  beforeDestroy () {
    if (process.env.NODE_ENV === "development" && this.isOpen) this.$emit('onClose')
  }
}
</script>